import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const editUser = async (
  user_id,
  fullName,
  email,
  phone,
  role,
  status,
  password,
  confirmPassword,
  permissions,
) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/user/`,
      {
        user_id,
        fullName,
        email,
        phone,
        role,
        status,
        password,
        confirmPassword,
        permissions,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );

    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};
const createUser = async (
  fullName,
  email,
  phone,
  role,
  status,
  password,
  confirmPassword,
  permissions,
) => {
  try {
    const token = getToken();
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/user/`,
      {
        fullName,
        email,
        phone,
        role,
        status,
        password,
        confirmPassword,
        permissions,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return res;
  } catch (e) {
    console.log("Create User Error:", e.response);
    throw e;
  }
};

const getUserData = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/user/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("User data fetch error:", error);
    throw error;
  }
};

const getUserDataById = async (id) => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/user/?user_id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("User data fetch error:", error);
    throw error;
  }
};

const deleteUser = async (user_id) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/user/`,
      {
        data: { user_id },
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res;
  } catch (e) {
    console.error("Error deleting user:", e);
    return e;
  }
};

const settingUser = async (payload) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/user/`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

export {
  editUser,
  createUser,
  getUserData,
  getUserDataById,
  deleteUser,
  settingUser,
};
